import React, { PureComponent } from 'react';
import { Root } from './AddClient.css';
import PageTitle from '../Layout/components/PageTitle';
import Client from './components/Client';
import { Dialog } from '@material-ui/core';
import SendLink from './components/SendLink';
import instance from '../../request/http';
import { BASE_URL } from '../../store/config';
import { roleStr, ADD } from '../../common/common';
import Toast from '../Layout/components/Toast';
import { withRouter } from 'react-router-dom';

const CLIENT = 11;
const LINK = 22;
const INDIVIDUAL = "individual";
const CORPORATION = "corporation";
const AUDITED = "audited";
class AddClient extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            dialogTitle: "",
            dialogState: ADD,
            dialogData: null,
            dialogType: CLIENT,
        }
        this.handleClick = this.handleClick.bind(this);
        this.handleCreate = this.handleCreate.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleCloseDialog = this.handleCloseDialog.bind(this);
        this.handleSendCreate = this.handleSendCreate.bind(this);
        this.handleCloseToast = this.handleCloseToast.bind(this);
    }
    render() {
        const {
            open,
            dialogTitle,
            dialogData,
            dialogState,
            showToast,
            toastMsg,
            toastState,
        } = this.state;
        const showContent = () => {
            const { dialogType } = this.state;
            if (dialogType === CLIENT) {
                return <Client
                    handleCreate={this.handleCreate}
                    handleCancel={this.handleCancel}
                    title={dialogTitle}
                    data={dialogData}
                    state={dialogState}
                ></Client>
            } else if (dialogType === LINK) {
                return <SendLink
                    handleCreate={this.handleSendCreate}
                    handleCancel={this.handleCancel}
                    title={dialogTitle}
                    data={dialogData}
                    state={dialogState}
                ></SendLink>
            }
        }
        return (
            <Root>
                <PageTitle title="Add Client" subtitle="MANAGEMENT"></PageTitle>
                <div className="cardWapper c">
                    <div className="cardTitle">Two Ways to Add a Client</div>
                    <div className="h h-c">
                        <div className="card c" onClick={e => this.handleClick(e, "add")}>
                            <div className="title h h-bt">
                                <div>DIRECT ADDING A CLIENT</div>
                                <div className="titleImg c">
                                    <div className="lTitleImg"></div>
                                </div>
                            </div>
                            <div className="body c">
                                <div className="desc">Filling client’s personal info straightforward, there is no any waiting time.</div>
                                <div className="line"></div>
                                <div className="lImg"></div>
                                <div className="logoImg"></div>
                            </div>
                        </div>
                        <div className="card c" onClick={e => this.handleClick(e, "send")}>
                            <div className="title h h-bt">
                                <div>SEND A LINK TO CLIENT</div>
                                <div className="titleImg c">
                                    <div className="rTitleImg"></div>
                                </div>
                            </div>
                            <div className="body c">
                                <div className="desc">Sending a link to multiple Clients’ emails at one time, let them fill the infos by themselves.</div>
                                <div className="line"></div>
                                <div className="rImg"></div>
                                <div className="logoImg"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <Dialog maxWidth={false} open={open}>
                    {showContent()}
                </Dialog>
                <Toast
                    open={showToast}
                    msg={toastMsg}
                    state={toastState}
                    handleClose={this.handleCloseToast}
                ></Toast>
            </Root>
        );
    }
    componentDidMount() {
    }
    handleClick(e, name) {
        if (name === "add") {
            this.openDialog("ADD CLIENT", CLIENT, ADD);
        } else if (name === "send") {
            this.openDialog("SEND CLIENT", LINK, ADD);
        }
    }
    handleCreate(radioValue, data) {
        const { dialogType } = this.state;
        if (dialogType === CLIENT) {
            if (radioValue === INDIVIDUAL) {
                this.addIndividual(data)
            } else if (radioValue === CORPORATION) {
                this.addCorporation(data)
            }
        } else {
            console.log("create得到", data)
        }
    }
    handleSendCreate(tabIndex, iEmails, oEmails, handler_id, handler_team_id) {
        if (tabIndex === 0) {
            if (iEmails.length > 0 || !handler_id || !handler_team_id) {
                if (!iEmails[0]) {
                    this.showToast("Please fill in the complete information", "warning")
                    return;
                }
            }
        } else {
            if (oEmails.length > 0 || !handler_id || !handler_team_id) {
                if (!oEmails[0]) {
                    this.showToast("Please fill in the complete information", "warning")
                    return;
                }
            }
        }
        if (tabIndex === 0) {
            this.sendEmails(handler_id, handler_team_id, iEmails, "individual");
        } else if (tabIndex === 1) {//公司
            this.sendEmails(handler_id, handler_team_id, oEmails, "corporation", "corp");
        }
    }
    sendEmails(handler_id, handler_team_id, emails, subject, target = "") {
        for (const email of emails) {
            const obj = {
                target,
                email,
                subject,
                handler_id,
                handler_team_id
            }
            this.sendEmail(obj);
        }
    }
    handleCancel() {
        this.closeDialog();
    }
    handleCloseDialog() {
        this.closeDialog();
    }
    showToast(toastMsg, toastState) {
        this.setState(() => ({
            showToast: true,
            toastState,
            toastMsg
        }))
    }
    handleCloseToast() {
        this.setState(() => ({
            showToast: false
        }))
    }
    closeDialog() {
        this.setState(() => ({
            open: false,
            dialogData: null,
        }));
    }
    openDialog(title, type, state) {
        this.setState(() => ({
            open: true,
            dialogTitle: title,
            dialogState: state,
            dialogType: type
        }));
    }
    //------------request----------------
    addIndividual(obj) {
        const params = {
            // related_parties: obj.related_parties,
            first_name: obj.first_name,
            last_name: obj.last_name,
            email: obj.email,
            phone: obj.phone,
            wechat: obj.wechat,
            referral_source: obj.referral_source,
            note: obj.note,
            // handlers: obj.handlers,
        }

        instance.post(BASE_URL + roleStr() + '/clients/individual', params).then((res) => {
            console.log(res)
            const id = res.data.data.id;
            this.iApproval(id);
        }).catch((err) => {
            const msg = err.response.data.message;
            this.showToast(msg, "error");
        })
    }
    addCorporation(obj) {
        const params = {
            // referral_source: obj.referral_source,
            // related_parties: obj.related_parties,
            // members: obj.members,
            name: obj.name,
            address: obj.address,
            note: obj.note,
            contacts: obj.contacts,
            // handlers: obj.handlers,
        }
        instance.post(BASE_URL + roleStr() + '/clients/corporation', params).then((res) => {
            console.log(res)
            const id = res.data.data.id;
            this.cApproval(id);
        }).catch((err) => {
            const msg = err.response.data.message;
            this.showToast(msg, "error");
        })
    }
    sendEmail(obj) {
        const params = {
            email: obj.email,
            target: obj.target,
            subject: obj.subject,
            handler_id: obj.handler_id,
            handler_team_id: obj.handler_team_id
        }
        instance.post(BASE_URL + 'send/email', params).then((res) => {
            console.log(res)
            this.showToast("Sent successfully", "success");
            this.closeDialog();
        }).catch((err) => {
            const msg = err.response.data.message;
            this.showToast(msg, "error");
        })
    }
    iApproval(client_id) {
        const params = {
            state: AUDITED,
        }
        console.log("params", params)
        instance.put(BASE_URL + roleStr() + '/clients/' + client_id + '/individual', params).then((res) => {
            console.log("审核", res)
            this.showToast("Added successfully", "success");
            this.closeDialog();
        }).catch((err) => {
            const msg = err.response.data.message;
            this.showToast(msg, "error");
        })
    }
    cApproval(client_id) {
        const params = {
            state: AUDITED,
        }
        instance.put(BASE_URL + roleStr() + '/clients/' + client_id + '/corporation', params).then((res) => {
            console.log(res)
            this.showToast("Added successfully", "success");
            this.closeDialog();
        }).catch((err) => {
            const msg = err.response.data.message;
            this.showToast(msg, "error");
        })
    }
}

export default withRouter(AddClient);